<template>
  <div class="template-footer">
    <div class="footer">
      <div class="leftSide">
        <p><b>Canon Vision</b> Virtual Pro AV Event &#169; Copyright 2020 All Rights Reserved.</p>
        <p v-html="$t('footer.privacyPolicyFooter')"></p>
      </div>
      <div class="rightSide">
        <p>
          <a target="_blank" rel="noopener noreferrer" href="http://reydar.com/virtual-events" style="color: #000 !important;">
            This Virtual Event is powered by <img style="height: 12px;vertical-align: baseline;width: auto;object-fit: contain;" src="https://res.cloudinary.com/enginecreative/image/upload/v1599495272/Reydar/Canon/Reydar_Logo_kzslwx.png">
          </a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '@/plugins/i18n';
export default {
  name: 'Footer',
  methods: {
    langSpanish(value){
      let langSpanish = value.target.innerText
      console.log(langSpanish)
      if(langSpanish === 'English'){
        console.log(langSpanish + 'EN')
        i18n.locale = 'en'
      }
      else if(langSpanish === 'Español'){
        console.log(langSpanish + 'ES')
        i18n.locale = 'es'
      } else if(langSpanish === 'Français'){
        console.log(langSpanish + 'Fr')
        i18n.locale = 'fr'
      } else if(langSpanish === 'Italiano'){
        console.log(langSpanish + 'It')
        i18n.locale = 'it'
      } else if(langSpanish === 'Deutsch'){
        console.log(langSpanish + 'de')
        i18n.locale = 'de'
      } else if(langSpanish === 'Pусский'){
        console.log(langSpanish + 'ru')
        i18n.locale = 'ru'
      } else{
        console.log('Unknown')
      }
    },
  }
}
</script>

<style scoped lang="scss">
.template-footer{
  background-color: #eaeaea;
  padding: 15px 0;

  .footer{
    width: 70%;
    max-width: 1600px;
    min-width: 1200px;
    margin: 0 auto;

    .leftSide{
      width: 50%;
      display: inline-block;
    }
    .rightSide{
      width: 45%;
      display: inline-block;
      margin-left: 5%;
      text-align: right;
      vertical-align: top;

      a{
        color: $color3 !important;
        font-weight: 500 !important;
      }
    }
    p{
      margin-bottom: 0px;
      font-size: 14px;
      line-height: 15px;
      color: $color2;
    }
  }
}
@media (max-width: 1209px){
  .template-footer{
    background-color: $color3;
    padding: 0;
    margin-top: 30px;

    .footer{
      width: 100%;
      max-width: 1600px;
      min-width: 0;
      margin: 0 auto;
      background-color: $color3;
      padding: 30px 15px;
      text-align: center;

      .leftSide{
        width: 100%;
        margin-bottom: 15px;
      }
      .rightSide{
        width: 100%;
        margin: 0px;
        text-align: center;
      }
    }
  }
}
</style>
